module.exports = __webpack_public_path__ + "static/4-9bab5d63e75590572c2fea84bd6ab6ed.jpeg";